export default __webpack_public_path__ + "static/profile-three-mobile-ecc966de4400d1bf53e7c94d3c89a1a2.jpg";